// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';

import CoreComponent from './internal-do-not-use-core';
import { applyDisplayName } from '../internal/utils/apply-display-name';
import { validateProps } from '../internal/base-component';



const Button = React.forwardRef((props, ref) => {
    validateProps('Button', props, ["style"], {});
    return React.createElement(CoreComponent, {ref,...props});
});


applyDisplayName(Button, 'Button');
export default Button;
